<script>
	import { Button } from "sveltestrap";
	import Loader from "../Loader/Loader.svelte";
	export let buttonText = "";
	export let textStyle = "";
	export let onClick = () => {};
	export let icon = "";
	export let disabled = false;
	export let color = "primary";
	export let outline = false;
	export let load = false;
	export let style = "";
	export let keydown = false;
</script>

<Button
	class={`fds-button`}
	on:click={onClick}
	{disabled}
	{color}
	{outline}
	{style}
	on:keydown={(e) => {
		if (keydown && e.key === "Enter") {
			onClick();
		}
	}}
>
	<span class="d-flex align-items-center">
		{#if icon}
			<img src={icon} alt="icon-svg" class="sidebarlogo mx-1" />
		{/if}
		<span class="mx-2" style={"font-weight: bold; " + textStyle}>
			{#if load}
				<Loader />
			{:else}
				{buttonText}
			{/if}
		</span>
	</span>
</Button>

<style>
	:global(.fds-button.btn-primary) {
		background-color: var(--fds-primary);
		color: white;
	}

	:global(.fds-button.btn-outline-danger) {
		border-color: #d60c0c;
		color: #d60c0c;
	}

	:global(.fds-button.btn-custom-blue) {
		background-color: #003bed;
		color: white;
	}

	:global(.fds-button.btn-custom-blue:hover) {
		background-color: #0026a3;
	}

	:global(.fds-button.btn-outline-danger:hover) {
		background-color: initial;
	}
</style>
